/* The Supabase client and the read-only RPCs the reveal needs. Same project as the live site;
   the anon key is public by design and every call is gated by RLS / the RPC's own checks.
   Nothing here writes. Writes arrive with the account and dashboard work (PRD A1, E1). */
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { PageConfig, Submission } from "@/types/legacy";

const URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let client: SupabaseClient | null = null;
export function supabase(): SupabaseClient {
  if (!URL || !KEY) throw new Error("Supabase is not configured: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env");
  if (!client) client = createClient(URL, KEY);
  return client;
}
export const supabaseConfigured = !!(URL && KEY);

/* What get_reveal returns (the live RPC's shape): the page config as published, every approved
   message with its media, the photo wall, the category order and a few counts. */
export interface RevealPayload {
  config: PageConfig;
  messages: Submission[];
  photoWall: { url: string; caption?: string; name?: string }[];
  groupsOrder?: string[];
  stats?: Record<string, number>;
  scheduled?: boolean | { at: string };
}

async function rpc<T>(name: string, args: Record<string, unknown>): Promise<T> {
  const r = await supabase().rpc(name, args);
  if (r.error) throw new Error(r.error.message);
  return r.data as T;
}

export const getReveal = (token: string) => rpc<RevealPayload>("get_reveal", { p_token: token });
export const shortInfo = (word: string) => rpc<{ slug: string; kind: "reveal" | "trailer"; protected: boolean; honoreeName?: string; displayName?: string }>("short_info", { p_word: word });
export const openShort = (word: string, pass = "") => rpc<{ slug: string; token: string; kind: "reveal" | "trailer" }>("open_short", { p_word: word, p_pass: pass });
export const getLanding = (slug: string) => rpc<Partial<PageConfig>>("get_landing", { p_slug: slug });
